import React from 'react';
import { DateField, Show, TextField } from 'react-admin';
import { Grid, GridShowLayout } from '../../components/wrapper';
import { AmountField, LinkField } from '../../components/fields';

const AccountingAccountTransferShow = props => (
	<Show {...props}>
		<GridShowLayout>
			<Grid container>
				<Grid item xs>
					<TextField source="id" />
					<DateField source="creationDateTime" showTime={true} />
					<TextField source="transferType" />
					<AmountField
						source="amount"
						label="resources.accountingAccountTransfers.labels.amount"
					/>
					<AmountField
						source="amountLC"
						label="resources.accountingAccountTransfers.labels.amountLC"
					/>
					<LinkField source="fromAccountId" type={'Account'} />
					<LinkField source="toAccountId" type={'Account'} />
					<LinkField source="owner" />
				</Grid>
				<Grid item xs>
					<TextField source="description" />
					<TextField source="transferQualifier" />
					<TextField source="transferStatus" />
					<LinkField source="cancelTransferId" type={'Account'} />
					<LinkField source="cancelledTransferId" type={'Account'} />
				</Grid>
			</Grid>
		</GridShowLayout>
	</Show>
);

export default AccountingAccountTransferShow;
